import { SIZE } from '../constants';
import { createSelector } from 'reselect';
export const getSizeItems = createSelector([(state) => state.page.template, (state, locale) => locale], (template, locale) => {
    if (!template || !template.pageSize)
        return [];
    return Object.keys(SIZE).reduce((sizes, s) => {
        template.pageSize[s] &&
            sizes.push({
                value: s,
                label: locale[s.toLowerCase()] || s,
            });
        return sizes;
    }, []);
});
//# sourceMappingURL=selectors.js.map